<template>
  <div class="container">
    <h2>Your Personalized Astrology Reports</h2>
    <p style="text-align: justify;">
      Your <b>personalized Vedic astrology reports</b> and expert interpretations are meticulously crafted using authentic principles to deliver deep insights into your life. 
      Designed to <b>bring awareness, clarity, and meaningful guidance on your major life themes</b>, each report empowers you to navigate your journey with confidence and make informed decisions proactively.              
      Now available at our <b>dedicated reports portal</b>.
    </p>

     <a href="https://www.vedicastrologyreport.com" target="_blank" class="cta-button">VedicAstrologyReport.com →</a>

    <!--
    
    <div 
      class="report-box"
      @mouseover="hoverIndex = 1"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 1 }"
    >
      <h3 class="report-title">Foundational Astrology Report</h3>
      <p>This report offers a <b>foundational analysis of your birth chart</b>, providing an insightful understanding of your core life patterns by exploring three key elements: Your <b>Ascendant</b>, <b>Planetary Placements</b>, and <b>House Lord Placements</b>.</p>

      <a @click="activate('purchase-foundational-report')" class="cta-button">Learn More</a>      
    </div>
    
    -->

    <div 
      class="report-box"
      @mouseover="hoverIndex = 2"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 2 }"
    >
    <h3 class="report-title">Planetary Positions Report</h3>
    <p style="text-align: justify;">The Planetary Positions Report analyzes the <b>placement of planets in your birth chart</b>, explaining how they influence various aspects of your life. It covers <b>planetary significations, dignity, rulership, and their combined effects on major life areas</b> with actionable advice to maximize strengths and navigate potential difficulties.</p>
    <a @click="showPlanetaryPositionsReport()" class="cta-button">View Sample Report</a>
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 3"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 3 }"
    >
    <h3 class="report-title">House Analysis Report</h3>
    <p style="text-align: justify;">The House Analysis Report <b>explores how each house lord influences your life when placed in a different house</b> in your birth chart. It presents this information in a clear and easy-to-understand way, helping you discover how various areas of your life are connected and revealing the patterns, strengths, and themes that naturally shape your life journey.</p>
    <a @click="showHouseAnalysisReport()" class="cta-button">View Sample Report</a>
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 4"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 4 }"
    >
    <h3 class="report-title">Nakshatra Influence Report</h3>
    <p style="text-align: justify;">An in-depth <b>exploration of the Nakshatras in which your planets reside</b>, uncovering their influence on the expression of planetary energies in your birth chart.
        Each Nakshatra carries unique characteristics that <b>refine the way a planet manifests its energy in your life</b>.
      </p>
      <a @click="showNakshatraInfluenceReport()" class="cta-button">View Sample Report</a>  
    </div>

    <div 
      class="report-box"
      @mouseover="hoverIndex = 5"
      @mouseleave="hoverIndex = null"
      :class="{ 'hovered': hoverIndex === 5 }"
    >
    <h3 class="report-title">Mahadasha Analysis Report</h3>
    <p style="text-align: justify;">The Mahadasha Analysis Report <b>explains the planetary periods</b> (Mahadashas) you experience in life, unveiling the karmic cycles and its profound influence on your life’s journey and key turning points.
        Each Mahadasha is ruled by a different planet and <b>shapes your key life areas over a specific time frame</b>.
      </p>
      <a @click="showMahadashaAnalysisReport()" class="cta-button">View Sample Report</a>  
    </div>

    <h2>Find the Right Report for You</h2>
    <p style="text-align: justify;">
      Each report offers unique insights <b>tailored based on the different components of your
      natal chart</b>. If you're still unsure, consider these recommendations:  
    </p>
    <ul>
      <li style="padding: 5px;"><b>Want to understand planetary influences in detail?</b> → Get the Planetary Positions Report</li>  
      <li style="padding: 5px;"><b>Curious about how life areas are shaped</b> by Astrological houses? → Get the House Analysis Report</li>  
      <li style="padding: 5px;"><b>Interested in how Nakshatras impact planetary expression?</b> → Get the Nakshatra Influence Report</li>  
      <li style="padding: 5px;"><b>Looking to uncover insights from your past and strategically navigate your future using Dasha cycles?</b> 
        → Get the Mahadasha Analysis Report</li>  
    </ul>
    <p style="text-align: justify;">
      Whichever report you choose, <b>you'll gain valuable insights and self-awareness</b> to make informed decisions and align with your true path.
    </p>

    <br/>
    <h3>For Those Who Want Complete Insights – Get All Reports!</h3>
    <p style="text-align: justify;">
      For those seeking a complete, in-depth understanding of their birth chart, <b>getting all reports provides the fullest picture of how planetary energies shape your life</b>.
      Whether you are new to Vedic astrology or looking for advanced insights, <b>getting all
      reports ensures nothing is left unexplored</b> - providing you with the most
      comprehensive and personalized Vedic astrological guidance available.      
    </p>


    <a href="https://www.vedicastrologyreport.com" target="_blank" class="cta-button">VedicAstrologyReport.com →</a>

  </div>
</template>

<script>

import ApiBaseUrl from '../http-api-base-url'

export default {
  data() {
    return {
      hoverIndex: null
    };
  },
  methods: {

    showPlanetaryPositionsReport() {
        window.open(ApiBaseUrl() + '/site/var/api/report/sample/pppr?', "_blank");
    },  

    showHouseAnalysisReport() {
        window.open(ApiBaseUrl() + '/site/var/api/report/sample/phar?', "_blank");
    },

    showNakshatraInfluenceReport() {
        window.open(ApiBaseUrl() + '/site/var/api/report/sample/pnir?', "_blank");
    },

    showMahadashaAnalysisReport() {
        window.open(ApiBaseUrl() + '/site/var/api/report/sample/pmar?', "_blank");
    },  

  }
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 20px;
  background-color: #f8f9fa;
  color: #333;
}

.report-title {
  color: #087F8C
}

p, ul {
  text-align: left;
}
ul {
  padding-left: 20px;
}

.container {
  max-width: 800px;
  margin: 30px auto;
  padding-right: 25px;
  padding-left: 25px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.report-box {
  background: #EDF6F9;
  padding: 15px;
  margin: 15px 0;
  border-left: 5px solid #2c3e50;
  border-radius: 5px;
  transition: transform 0.2s ease, background-color 0.2s ease;
  text-align: left; /* Left-aligned content */
}
.report-box.hovered {
  transform: scale(1.01);
  background: #bbdefb;
}
h1, h2, h3 {
  color: #2c3e50;
  text-align: left; /* Left-align headings */
}
p {
  line-height: 1.6;
  text-align: left; /* Left-align paragraphs */
}
.cta-button {
  display: inline-block;
  padding: 12px 25px;
  background-color: #087F8C;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  margin: 20px 0;
  font-weight: bold;
  text-align: center;
  width: fit-content;
  cursor: pointer;
}
.cta-button:hover {
  background-color: #218838;
}

/* Ensuring margin consistency across all screen sizes */
@media (max-width: 800px) {
  .container {
    margin: 20px; /* Apply same margin on mobile devices */
    padding: 15px; /* Reduce padding slightly for better spacing */
  }
}
</style>
